export default {
  isDev: () => process.env.NODE_ENV === 'development',
  isStaging: () => process.env.REACT_APP_ENVIRONMENT === 'staging',
  showReduxLogger: () => process.env.REACT_APP_SHOW_REDUX_LOGGER === 'true',
  showAPIErrorsInConsole: () => process.env.REACT_APP_LOG_API_ERRORS === 'true',
  showPusherInConsole: () => process.env.REACT_APP_PUSHER_IN_CONSOLE === 'true'
}
